import { render, staticRenderFns } from "./french_wordResources.vue?vue&type=template&id=43856e09&scoped=true"
import script from "./french_wordResources.vue?vue&type=script&lang=js"
export * from "./french_wordResources.vue?vue&type=script&lang=js"
import style0 from "./french_wordResources.vue?vue&type=style&index=0&id=43856e09&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43856e09",
  null
  
)

export default component.exports